import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'users/sessions',
    pluginName: 'ACTIVITY',
    entityName: 'USER',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
});

export const fetchUserActivityInit = () => {
    return crudActions.fetchInit();
};
export const fetchUserActivityStart = () => {
    return crudActions.fetchStart();
};
export const fetchUserActivitySuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchUserActivityFail = () => {
    return crudActions.fetchFail();
};

export const deleteUserActivityInit = () => {
    return crudActions.deleteInit();
};
export const deleteUserActivityStart = () => {
    return crudActions.deleteStart();
};
export const deleteUserActivitySuccess = () => {
    return crudActions.deleteSuccess();
};
export const deleteUserActivityFail = () => {
    return crudActions.deleteFail();
};
export const fetchUserActivityDataCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchUserActivityStart());
        try {
            let countRes = await rest.post("/users/sessions/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchUserActivitySuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchUserActivityFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch user activity."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchUserActivityFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch user activity."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchUserActivityData = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchUserActivityStart());
        try {
            let listRes = await rest.post("/users/sessions/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchUserActivitySuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchUserActivityFail());
            return []

        } catch (error) {
            dispatch(fetchUserActivityFail());
            return []
        }
    }
}

export const fetchClientTypesInit = () => {
    return crudActions.fetchInit();
};
export const fetchClientTypesStart = () => {
    return crudActions.fetchStart();
};
export const fetchClientTypesSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchClientTypesFail = () => {
    return crudActions.fetchFail();
};

export const fetchClientTypes = (data, options = {}) => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchClientTypesStart());
        try {
            let listRes = await rest.post("/supported-client-type/list", { listAll: true, formatForWEBUI: true, ...data });
            if (listRes && listRes.canceled) {
                return {};
            }
            if (listRes.data && listRes.data.succeeded && listRes.data.result?.data && !Array.isArray(listRes.data.result?.data)) {
                dispatch(fetchClientTypesSuccess(listRes.data.result.data));
                return listRes.data.result.data
            }
            snackActions.snackBar({
                message: `${listRes && listRes.data ? listRes.data.message : "Cannot fetch client types."}`,
                options: {
                    variant: 'warning'
                }
            });
            dispatch(fetchClientTypesFail());
            return {}
        } catch (error) {
            dispatch(fetchClientTypesFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch client types."}`,
                options: {
                    variant: 'error'
                }
            });
            return {}
        }
    }
};

export const removeSession = queryParams => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(deleteUserActivityStart());
        try {
            let res = await rest.post("/users/sessions/remove", queryParams);
            if (res.data && res.data.succeeded) {
                dispatch(deleteUserActivitySuccess({ deleted: {} }));
            }
            dispatch(deleteUserActivityFail());
            return { data: [], count: 0 };
        } catch (error) {
            dispatch(deleteUserActivityFail());
            return { data: [], count: 0 }
        }
    }
}

export const extendSession = queryParams => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post("/users/update-user-session", queryParams);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully extended session.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Could not extend session."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Could not extend session."}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}